// http://router.vuejs.org/en/
import Vue from 'vue'
import VueRouter from 'vue-router'

import URL from '../../../config.url'


Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'default'
    },

    {
        path: URL.page.home,
        name: 'page-home',
        meta: {
            page: URL.api.home,
            key: 'home',
            component: 'page-home'
        }
    },

    {
        path: URL.page.debug,
        name: 'page-debug',
        meta: {
            page: URL.api.home,
            key: 'home',
            component: 'page-debug',
            disableTracking: true
        }
    },

    {
        path: URL.page.news,
        name: 'page-news',
        meta: {
            page: URL.api.news,
            key: 'news',
            component: 'page-news'
        }
    },

    {
        path: URL.page.article,
        name: 'page-article',
        meta: {
            page: URL.api.article,
            key: 'article',
            component: 'page-article'
        }
    },

    {
        path: URL.page.sponsors,
        name: 'page-sponsors',
        meta: {
            page: URL.api.sponsors,
            key: 'sponsors',
            component: 'page-sponsors'
        }
    },

    {
        path: URL.page.teams,
        name: 'page-teams',
        meta: {
            page: URL.api.teams,
            key: 'teams',
            component: 'page-teams'
        }
    },

    {
        path: URL.page.teamProfile,
        name: 'page-team-profile',
        meta: {
            page: URL.api.teamProfile,
            key: 'teamProfile',
            component: 'page-team-profile'
        }
    },

    {
        path: URL.page.teamProfileFilter,
        name: 'page-team-profile-filter',
        meta: {
            page: URL.api.teamProfile,
            key: 'teamProfile',
            component: 'page-team-profile'
        }
    },

    {
        path: URL.page.player,
        name: 'page-player',
        meta: {
            page: URL.api.player,
            key: 'player',
            component: 'page-player'
        }
    },

    {
        path: URL.page.videos,
        name: 'page-videos',
        meta: {
            page: URL.api.videos,
            key: 'videos',
            component: 'page-videos'
        }
    },

    {
        path: URL.page.videosFilter,
        name: 'page-videos-filter',
        meta: {
            page: URL.api.videos,
            key: 'videos',
            component: 'page-videos'
        }
    },

    {
        path: URL.page.videoPlayer,
        name: 'page-video-player',
        meta: {
            page: URL.api.videoPlayer,
            key: 'videoPlayer',
            component: 'page-video-player'
        }
    },

    {
        path: URL.page.watchNow,
        name: 'page-watch-now',
        meta: {
            page: URL.api.watchNow,
            key: 'watchNow',
            component: 'page-watch-now'
        }
    },

    {
        path: URL.page.gallery,
        name: 'page-gallery',
        meta: {
            page: URL.api.gallery,
            key: 'gallery',
            component: 'page-gallery'
        }
    },

    {
        path: URL.page.galleryImage,
        name: 'page-gallery-image',
        meta: {
            page: URL.api.gallery,
            key: 'gallery',
            component: 'page-gallery'
        }
    },

    {
        path: URL.page.copyright,
        name: 'page-copyright',
        meta: {
            page: URL.api.copyright,
            key: 'copyright',
            component: 'page-copyright'
        }
    },

    {
        path: URL.page.policy,
        name: 'page-policy',
        meta: {
            page: URL.api.policy,
            key: 'policy',
            component: 'page-policy'
        }
    },

    {
        path: URL.page.terms,
        name: 'page-terms',
        meta: {
            page: URL.api.terms,
            key: 'terms',
            component: 'page-terms'
        }
    },

    {
        path: URL.page.esInformations,
        name: 'page-informations',
        meta: {
            page: URL.api.esInformations,
            key: 'esInformations',
            component: 'page-informations'
        }
    },

    {
        path: URL.page.esSeason,
        name: 'page-season',
        meta: {
            page: URL.api.esSeason,
            key: 'esSeason',
            component: 'page-season'
        }
    },

    {
        path: URL.page.esAbout,
        name: 'page-about',
        meta: {
            page: URL.api.esAbout,
            key: 'esAbout',
            component: 'page-about'
        }
    },

    {
        path: URL.page.esMatches,
        name: 'page-matches',
        meta: {
            page: URL.api.esMatches,
            key: 'esMatches',
            component: 'page-matches'
        }
    },

    {
        path: URL.page.esMatchesFilter,
        name: 'page-matches-filter',
        meta: {
            page: URL.api.esMatchesFilter,
            key: 'esMatchesFilter',
            component: 'page-matches'
        }
    },

    {
        path: URL.page.esMatchDetails,
        name: 'page-match-details',
        meta: {
            page: URL.api.esMatchDetails,
            key: 'esMatchDetails',
            component: 'page-match-details'
        }
    },

    {
        path: URL.page.esMatchDetailsFilter,
        name: 'page-match-details-filter',
        meta: {
            page: URL.api.esMatchDetails,
            key: 'esMatchDetails',
            component: 'page-match-details'
        }
    },

    {
        path: URL.page.esMatchDetailsFilterLang,
        name: 'page-match-details-filter-lang',
        meta: {
            page: URL.api.esMatchDetails,
            key: 'esMatchDetails',
            component: 'page-match-details'
        }
    },

    {
        path: URL.page.esStandings,
        name: 'page-standings',
        meta: {
            page: URL.api.esStandings,
            key: 'esStandings',
            component: 'page-standings'
        }
    },

    {
        path: URL.page.intraVideo,
        name: 'page-intra-video',
        meta: {
            page: URL.api.intraVideo,
            key: 'intraVideo',
            component: 'page-intra-video',
            disableTracking: true
        }
    },

    {
        path: URL.page[404],
        name: 'page-404',
        meta: {
            page: URL.api[404],
            key: ']',
            component: 'page-404'
        }
    }
]


const router = new VueRouter({
    routes,
    mode: 'history'
})


export default router



// WEBPACK FOOTER //
// ./src/scripts/components/app-main/Router.js